import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";

import Footer from "./Footer";
import TopBar from "./Topbar";
import { notifyUser } from "../utils/notifyUser";

const SubscribeAlerts = () => {
    const [email, setEmail] = useState(
        () => new URLSearchParams(window.location.search).get("email") || "",
    );
    const [submitted, setSubmitted] = useState(() => {
        const searchParams = new URLSearchParams(window.location.search);

        return (
            searchParams.get("subscribed") === "true" ||
            window.location.hash === "#subscription-confirmed"
        );
    });
    const [, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if(!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            setError("Please enter a valid email address.");
            notifyUser(null, "error", "Please enter a valid email address.", "toast", null, null, null, null, null, false, false, "top-center");
            return;
        }
        try {
            const res = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/api/alerts/subscribe`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email }),
                },
            );
            if(res.status === 409) {
                const data = await res.json();
                setError(data.error || "This email is already subscribed.");
                notifyUser(null, "error", data.error || "This email is already subscribed.", "toast", null, null, null, null, null, false, false, "top-center");
                return;
            }
            if(res.ok) {
                setSubmitted(true);
                notifyUser(null, "success", "Subscribed successfully!", "toast", null, null, null, null, null, false, false, "top-center");
            } else {
                const data = await res.json();
                setError(
                    data.error ||
                        "Subscription failed. Please try again later.",
                );
                notifyUser(null, "error", data.error ||
                        "Subscription failed. Please try again later.", "toast", null, null, null, null, null, false, false, "top-center");
            }
        } catch{
            setError("Subscription failed. Please try again later.");
            notifyUser(null, "error", "Subscription failed. Please try again later.", "toast", null, null, null, null, null, false, false, "top-center");
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-[#F5F7FA] text-gray-800 font-poppins">
            <TopBar />

            {/* Hero Section */}
            <section className="bg-navy text-white py-20 px-4 text-center shadow-lg relative overflow-hidden font-poppins">
                <h1 className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight drop-shadow-lg">
                    Stay Informed with AQi Alerts
                </h1>
                <p className="text-lg md:text-xl max-w-2xl mx-auto mb-2 font-medium">
                    Be the first to know about new investment offerings, company
                    news, and platform updates.
                </p>
                <p className="text-base max-w-xl mx-auto text-[#D4AF37]">
                    Sign up below to receive exclusive alerts and insights
                    directly in your inbox.
                </p>
            </section>

            {/* Subscription Form Section */}
            <main className="flex-1 flex flex-col items-center justify-center px-4 py-16 font-poppins">
                <div className="bg-white/90 shadow-2xl rounded-2xl p-10 w-full max-w-lg text-center border border-[#D4AF37] relative font-poppins">
                    {!submitted ? (
                        <>
                            <h2 className="text-2xl md:text-3xl font-bold mb-2 text-navy font-poppins">
                                Subscribe to AQi Alerts
                            </h2>
                            <p className="text-base mb-6 text-gray-600 font-poppins">
                                Enter your email to receive timely updates and
                                exclusive content.
                            </p>

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <input
                                    type="email"
                                    className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-navy text-lg transition font-poppins"
                                    placeholder="Enter your email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoFocus
                                />

                                <button
                                    type="submit"
                                    className="w-full bg-gradient-to-r from-navy to-[#0077b6] text-[#D4AF37] font-bold py-3 rounded-lg hover:from-[#00314d] hover:to-[#005377] transition text-lg shadow-md font-poppins"
                                >
                                    Subscribe
                                </button>
                            </form>
                            <div className="mt-6 text-xs text-gray-400 font-poppins">
                                We respect your privacy. Unsubscribe at any
                                time.
                            </div>
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center gap-4 py-8 animate-fade-in font-poppins">
                            <span className="text-4xl">🎉</span>
                            <div className="text-green-700 font-bold text-xl font-poppins">
                                Thank you for subscribing!
                            </div>
                            <div className="text-gray-600 text-base font-poppins">
                                You’ll receive our next update soon.
                                <br />
                                Check your inbox for a confirmation email.
                            </div>
                            <a
                                href="/"
                                className="mt-4 inline-block text-navy hover:underline text-sm font-poppins"
                            >
                                Back to Home
                            </a>
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default SubscribeAlerts;
